import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/content";
import { formatDate, formatDuration, formatViews } from "@/utils/content";

export default function VideoCard({ video }: { video: VideoItem }) {
  return (
    <Link
      to={`/videos/detail/${video.id}`}
      className="group flex w-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-video w-full overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title}的封面预览图`}
          title={`${video.title} - 挠痒视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
        />
        <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2 py-1 text-[11px] font-medium text-foreground-800">
          {video.category}
        </span>
        <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-md bg-foreground-950/75 px-1.5 py-1 text-[11px] text-background-50">
          <i className="ri-time-line text-xs"></i>
          {formatDuration(video.duration)}
        </span>
        <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50/90 text-foreground-900">
            <i className="ri-play-fill text-xl"></i>
          </span>
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="line-clamp-2-custom text-sm font-medium leading-relaxed text-foreground-950 md:text-base">
          {video.title}
        </h3>
        <div className="mt-auto flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-user-3-line"></i>
            {video.author}
          </span>
          <span className="whitespace-nowrap">{formatDate(video.date)}</span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {formatViews(video.views)}
          </span>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {video.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}